/* global fetch, FormData */

import { buildApiUrl } from "./config/api";

function isFormData(body: BodyInit | null | undefined): boolean {
  return typeof FormData !== "undefined" && body instanceof FormData;
}

export function withCredentials(init: RequestInit = {}): RequestInit {
  const headers = new Headers(init.headers || {});

  if (!isFormData(init.body) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  return {
    ...init,
    credentials: "include",
    headers,
  };
}

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  return fetch(buildApiUrl(path), withCredentials(init));
}
